(() => {
  // --------- Utilities ---------
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const drawer = $('#secondary-cart-drawer');
  const bodyEl = $('#secondary-cart-body');
  const subtotalEl = $('#scd-subtotal');

  if (!drawer || !bodyEl) return;

  // format Shopify "cents" -> locale currency
  function formatMoney(cents, currency) {
    const cur = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    const n = typeof cents === 'number' ? cents : parseInt(cents || 0, 10);
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n / 100);
  }

  // Open / close
  function openDrawer() {
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-busy', 'true');
    document.documentElement.style.overflow = 'hidden';
    // focus panel for a11y
    $('.scd__panel', drawer)?.focus({ preventScroll: true });
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    // let the transform finish before hiding
    setTimeout(() => drawer.classList.add('hidden'), 250);
  }

  // Close by overlay / button / ESC
  $$('[data-scd-close]', drawer).forEach(el => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => {
    if (drawer.getAttribute('aria-hidden') === 'false' && e.key === 'Escape') closeDrawer();
  });

  // Fetch current cart
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  // Render lines + subtotal
  function renderCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const currency =
      cart.currency ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'USD';

    bodyEl.innerHTML = cart.items
      .map((item) => {
        const hasDiscount =
          item.original_line_price > item.final_line_price;

        // Build the price HTML for this line
        const priceHTML = hasDiscount
          ? `
            <span class="Price Price--compareAt">
              ${formatMoney(item.original_line_price, currency)}
            </span>
            <span class="Price Price--highlight">
              ${formatMoney(item.final_line_price, currency)}
            </span>
          `
          : `
            <span class="Price">
              ${formatMoney(item.final_line_price, currency)}
            </span>
          `;

        return `
          <div class="scd-line" data-key="${item.key}">
            <img class="scd-line__img" src="${item.image}" alt="${item.product_title}">
            <div class="scd-line__info">
              <div class="scd-line__title">${item.product_title}</div>
              ${
                item.variant_title
                  ? `<div class="scd-line__variant">${item.variant_title}</div>`
                  : ''
              }
              <div class="scd-line__bottom">
                <div class="scd-qty">
                  <button class="scd-qty__btn" data-scd-qty="-1" aria-label="Decrease quantity">−</button>
                  <input class="scd-qty__input" type="number" min="0" value="${item.quantity}" inputmode="numeric" aria-label="Quantity">
                  <button class="scd-qty__btn" data-scd-qty="+1" aria-label="Increase quantity">＋</button>
                </div>
                <div class="scd-line__price">
                  ${priceHTML}
                </div>
                <button class="scd-line__remove scd__btn scd__btn--secondary" data-scd-remove type="button" style="margin-top:8px;">Remove</button>
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.items_subtotal_price, currency);
    }
    drawer.setAttribute('aria-busy', 'false');
  }

  // Update a line by key
  async function updateLine(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }

  // Refresh drawer content
  async function refreshAndOpen() {
    const cart = await getCart();
    renderCart(cart);
    openDrawer();
    document.dispatchEvent(new CustomEvent('secondary:cart:opened', { detail: { cart } }));
  }

  // Delegate clicks inside drawer for qty / remove
  bodyEl.addEventListener('click', async (e) => {
    const line = e.target.closest('.scd-line');
    if (!line) return;
    const key = line.getAttribute('data-key');

    // +/- buttons
    const qtyBtn = e.target.closest('[data-scd-qty]');
    if (qtyBtn) {
      const delta = qtyBtn.getAttribute('data-scd-qty') === '+1' ? 1 : -1;
      const input = line.querySelector('.scd-qty__input');
      const next = Math.max(0, parseInt(input.value || '0', 10) + delta);
      await updateLine(key, next);
      await refreshAndOpen();
      return;
    }

    // Remove
    if (e.target.closest('[data-scd-remove]')) {
      await updateLine(key, 0);
      await refreshAndOpen();
    }
  });

  // Commit change when user types qty manually
  bodyEl.addEventListener('change', async (e) => {
    const input = e.target.closest('.scd-qty__input');
    const line = e.target.closest('.scd-line');
    if (!input || !line) return;
    const key = line.getAttribute('data-key');
    const val = Math.max(0, parseInt(input.value || '0', 10));
    await updateLine(key, val);
    await refreshAndOpen();
  });

  // ------------- UNIVERSAL ADD-TO-CART CATCHERS -------------

  // 1) Intercept *real* form submits to /cart/add (product pages and older quick-adds)
  document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.matches('form[action*="/cart/add"]')) return;
  if (form.hasAttribute('data-bypass-secondary')) return;

  e.preventDefault();
  try {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Add failed');

    await refreshAndOpen();   // open the mini-cart sidebar
  } catch (err) {
    console.error('[secondary-cart] form add failed', err);
    // Optional: show an inline error or toast here instead of redirecting
    // but DO NOT call form.submit(), or you'll be sent to the cart page.
  }
});

  // 2) Optional: support a “Quick Add” button that directly specifies a variant id
  //    Add data-quick-add-variant="{{ variant.id }}" to your Quick Add buttons if needed.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add-variant]');
    if (!btn) return;
    e.preventDefault();
    const id = Number(btn.getAttribute('data-quick-add-variant'));
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      await refreshAndOpen();
    } catch (err) {
      console.error('[secondary-cart] quick-add failed', err);
    }
  });

  // 3) Hook fetch so we catch *theme-driven* AJAX adds (no matter who sends them)
  (function hookFetch(){
    if (!window.fetch || window.__scdFetchHooked) return;
    window.__scdFetchHooked = true;
    const orig = window.fetch;
    window.fetch = async function(...args){
      const resp = await orig.apply(this, args);
      try {
        const req = args[0];
        const url = typeof req === 'string' ? req : (req && req.url) || '';
        const method = (args[1]?.method || (typeof req !== 'string' && req?.method) || 'GET').toUpperCase();
        if (method === 'POST' && url.includes('/cart/add')) {
          await refreshAndOpen();
        }
      } catch(_) {}
      return resp;
    };
  })();

  // 4) Hook XHR for older code paths
  (function hookXHR(){
    if (!window.XMLHttpRequest || window.__scdXHRHooked) return;
    window.__scdXHRHooked = true;
    const X = window.XMLHttpRequest;
    const open = X.prototype.open;
    const send = X.prototype.send;

    X.prototype.open = function(method, url, ...rest){
      this.__scdMethod = (method || 'GET').toUpperCase();
      this.__scdURL = url || '';
      return open.call(this, method, url, ...rest);
    };
    X.prototype.send = function(...args){
      this.addEventListener('load', async () => {
        try {
          if (this.__scdMethod === 'POST' && String(this.__scdURL).includes('/cart/add')) {
            await refreshAndOpen();
          }
        } catch(_) {}
      });
      return send.apply(this, args);
    };
  })();
  // Listen for Quick Add / other code dispatching `product:added`
  document.addEventListener('product:added', () => {
    refreshAndOpen();
  });

})();
/* ===== PDP primary selector: swap hero image on color change ===== */
(function () {
  function getProductJSON() {
    const el = document.querySelector('script[type="application/json"][data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function switchGalleryToImage(imageId, imageUrl) {
    // Try clicking a matching thumbnail/media (many themes respond to this)
    if (imageId) {
      const thumb = document.querySelector(
        `[data-thumbnail-id="${imageId}"], [data-media-id="${imageId}"], [id="Image${imageId}"]`
      );
      if (thumb && typeof thumb.click === 'function') thumb.click();
      try { location.hash = 'Image' + imageId; } catch (_) {}
    }
    // Fallback: directly swap the main image src
    if (imageUrl) {
      const mainImg = document.querySelector(
        '.Product__Slideshow .is-active img, .Product__Media img, .Product__Gallery img, .Product__Image img, img[data-product-featured]'
      );
      if (mainImg) {
        if ('srcset' in mainImg) mainImg.srcset = '';
        mainImg.src = imageUrl.replace('{width}', '1200');
      }
    }
  }

  function findImageForVariantId(variantId) {
    const product = getProductJSON();
    if (!product || !Array.isArray(product.variants)) return {};
    const v = product.variants.find(v => String(v.id) === String(variantId));
    if (!v) return {};
    const imageId = v?.featured_media?.id || v?.image_id || null;
    const imageUrl =
      v?.featured_media?.preview_image?.src ||
      v?.featured_image?.src ||
      v?.image ||
      null;
    return { imageId, imageUrl };
  }

  // 1) When the PDP color swatch (Radio) is changed
  document.addEventListener('change', function (e) {
    const swatch =
      e.target.closest('.ColorSwatch__Radio, .swatch__input, .variant-input'); // add your PDP swatch class if needed
    if (!swatch) return;

    // Prefer explicit data from the swatch (fast path)
    const imageId = swatch.getAttribute('data-image-id');
    const imageUrl = swatch.getAttribute('data-image-url');
    if (imageId || imageUrl) {
      switchGalleryToImage(imageId, imageUrl);
      return;
    }

    // If swatch doesn't carry image data, try variant <select name="id">
    const select = document.querySelector('select[name="id"]');
    if (select && select.value) {
      const { imageId: vid, imageUrl: vurl } = findImageForVariantId(select.value);
      if (vid || vurl) switchGalleryToImage(vid, vurl);
    }
  });

  // 2) Also handle <select name="id"> changes (some themes don’t use swatch radios)
  document.addEventListener('change', function (e) {
    const select = e.target.matches('select[name="id"]') ? e.target : null;
    if (!select) return;
    const { imageId, imageUrl } = findImageForVariantId(select.value);
    if (imageId || imageUrl) switchGalleryToImage(imageId, imageUrl);
  });

  // 3) If your theme dispatches a custom event on variant change, handle that too
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail?.variant;
    if (!variant) return;
    const imageId =
      variant?.featured_media?.id || variant?.image_id || null;
    const imageUrl =
      variant?.featured_media?.preview_image?.src ||
      variant?.featured_image?.src ||
      variant?.image ||
      null;
    if (imageId || imageUrl) switchGalleryToImage(imageId, imageUrl);
 });
})();